export const CircleTeaserGroupWidgetId = 'CircleTeaserGroupWidget';

export enum CircleTeaserGroupWidgetAttributes {
  CIRCLE_TEASER = 'circleTeaser',
}
